import configData from '../../config.json';
import axios from 'axios';

export const Authentication = async (v) => {
    var config = {
        method: 'POST',
        url: configData.API_ENDPOINT + `authorization`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const Audits = async (v) => {
    var config = {
        method: 'POST',
        url: configData.API_ENDPOINT + `audits`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const ChangeStudentPassword = async (v, id) => {
    var config = {
        method: 'PATCH',
        url: configData.API_ENDPOINT + `users/${id}`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const ForgotPasswordLink = async (v) => {
    var config = {
        method: 'POST',
        url: configData.API_ENDPOINT + `password/forgot-password`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}

export const ResetPassword = async (token, v) => {
    var config = {
        method: 'POST',
        url: configData.API_ENDPOINT + `password/reset-password/${token}`,
        headers: {
            'Content-Type': 'application/json',
        },
        data: v,
    };
    return axios(config)
        .then(function (response) {
            return response.data;
        })
        .catch(function (error) {
            return error;
        });
}